import type { QueryClient } from '@tanstack/react-query';
import { QueryKeys } from 'utils/queryKeys';
import type {
  DocumentSectionsResponse,
  SectionByDocumentIdApiResponse,
  BlocksFromSectionsByDocumentIdApiResponse,
} from 'services/documents/DocumentRepository';
import type { JSONCommentDto } from '@proposify/document-service-api-schema';

export const updateBlockContentInCache = (
  queryClient: QueryClient,
  contentId: string,
  blockId: string,
  contentObject: JSONCommentDto | null
): void => {
  const gridsQueryKey = QueryKeys.getGridsByContentId(contentId);
  const currentGridsData = queryClient.getQueryData(gridsQueryKey) as DocumentSectionsResponse;

  if (!currentGridsData) return;

  const updatedSections = currentGridsData.sections.map((section: SectionByDocumentIdApiResponse) => ({
    ...section,
    blocks: section.blocks.map((block: BlocksFromSectionsByDocumentIdApiResponse) => {
      if (block.gridId === blockId) {
        return {
          ...block,
          htmlContent: JSON.stringify(contentObject),
          contentObject,
        };
      }
      return block;
    }),
  }));

  queryClient.setQueryData(gridsQueryKey, {
    ...currentGridsData,
    sections: updatedSections,
  });
};
